import React from "react";

export default class StringWithClassDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && this.props.data.text && typeof this.props.data.text !== 'undefined') {
      return (
        <div className='StringWithClassDataType'>
          <div dangerouslySetInnerHTML={{ __html: this.props.data.text }} className={this.props.data.classes}></div>
        </div>
      );
    } else {
      return (
        <i>{I18n.t('none')}</i>
      )
    }
  };
};